import gql from 'graphql-tag';

export const AVAILABLE_DOCUMENT_TYPES_FOR_CREATION_QUERY = gql`
  query availableDocumentTypesForCreationQuery {
    availableDocumentTypesForCreation
  }
`;

export const DOCUMENT_LIST_QUERY = gql`
  query documentListQuery($accountId: ID!) {
    account(id: $accountId) {
      documents {
        id
        type
        versionNumber
        updatedBy {
          firstName
          lastName
        }
        updatedOn
        scheduledOn
        enforcedOn
        status
        url
      }
    }
  }
`;

export const CREATE_DOCUMENT_MUTATION = gql`
  mutation createDocumentMutation($input: CreateDocumentInput!) {
    createDocument(input: $input)
  }
`;

export const UPDATE_DOCUMENT_STATUS_MUTATION = gql`
  mutation updateDocumentStatusMutation($input: UpdateDocumentStatusInput!) {
    updateDocumentStatus(input: $input)
  }
`;

export const UPDATE_DOCUMENT_SCHEDULED_ON_DATE_MUTATION = gql`
  mutation updateDocumentScheduledOnDateMutation($input: UpdateDocumentScheduledOnDateInput!) {
    updateDocumentScheduledOnDate(input: $input)
  }
`;

export const UPDATE_DOCUMENT_CONTENT_MUTATION = gql`
  mutation updateDocumentContentMutation($input: UpdateDocumentContentInput!) {
    updateDocumentContent(input: $input)
  }
`;

export const UPDATE_DOCUMENTS_STATUS_MUTATION = gql`
  mutation updateDocumentChangeAcceptanceRequestsStatusesMutation(
    $input: UpdateDocumentChangeAcceptanceRequestsStatusesInput!
  ) {
    updateDocumentChangeAcceptanceRequestsStatuses(input: $input)
  }
`;

export const GET_PUBLIC_DOCUMENT_URL_QUERY = gql`
  query getPublicDocumentUrlQuery($type: DocumentType!) {
    publicDocumentUrl(type: $type) {
      url
    }
  }
`;